import { Text } from '../ui'
import { formatCurrency, formatInitalMayus, formatRut } from '../../utils/formatter'
import clsx from 'clsx'
import estrellaIcon from '../../../assets/svgIcons/estrella.svg'

const styles = {
  th: 'first:pl-4 sm:first:pl-12 last:pr-4 sm:last:pr-12 py-2 text-xs sm:text-sm title-table text-left',
  td: 'first:pl-4 sm:first:pl-12 last:pl-2 last:pr-4 sm:last:pr-12 py-2 text-left',
  firstLine: 'first-line-table text-xs sm:text-sm',
  secondLine: 'second-line-table text-[10px] sm:text-xs'
}

const TableTop5 = ({ data, title, header1, header2 }) => {
  const safeData = Array.isArray(data) ? data : []
  const emptyRows = Math.max(0, 5 - safeData.length)

  return (
    <div className='relative flex h-full w-full flex-col overflow-x-auto rounded-card bg-primary py-4 text-white shadow-card sm:overflow-hidden sm:py-5'>
      <div className='relative flex h-full w-full flex-col'>
        <img
          src={estrellaIcon}
          alt='Estrella'
          className='absolute -top-14 -right-10 w-28 h-28 sm:w-32 sm:h-32'
          style={{ clipPath: 'inset(0 0 0 0)' }} // Esto asegura que la estrella se recorte en el contenedor
        />
        <div className='flex h-full flex-col justify-start'>
          <h2 className='text-yellow-300 text-xl sm:text-3xl font-semibold mb-4 px-4 sm:px-12'>{title}</h2>
          <table className='table-auto w-full text-xs sm:text-sm'>
            <thead>
              <tr className='border-b-4 border-yellow-300'>
                <th className={styles.th}>{header1}</th>
                <th className={styles.th}>{header2}</th>
              </tr>
            </thead>
            <tbody>
              {data?.[0] ? (
                <>
                  {data?.map((cliente, index) => (
                    <tr key={index} className='gap-6 even:bg-secondary/20'>
                      <td className={clsx('overflow-hidden', styles.td)}>
                        <Text className={clsx(styles.firstLine, 'max-w-[140px] sm:max-w-40 whitespace-normal sm:whitespace-nowrap break-words')}>
                          {cliente.companyName && formatInitalMayus(cliente.companyName)}
                        </Text>
                        <br/>
                        <Text className={styles.secondLine}>{formatRut(cliente.rut)}</Text>
                      </td>

                      <td className={clsx('w-32 sm:w-44 text-right', styles.td)}>
                        <Text className={clsx(styles.firstLine, 'whitespace-nowrap')}>
                          {formatCurrency(cliente.amount)}
                        </Text>
                        <br/>
                        <Text className={styles.secondLine}>
                          {cliente.invoicesCount + ' Facturas'}
                        </Text>
                      </td>
                    </tr>
                  ))}
                  {[...Array(emptyRows)].map((_, index) => (
                    <tr key={`empty-${index}`} className='gap-6 even:bg-secondary/20'>
                      <td className={styles.td}>
                        <Text className={clsx(styles.firstLine, 'pl-4 sm:pl-8')}>-</Text>
                        <Text className={clsx(styles.secondLine, 'pl-4 sm:pl-8 text-transparent')}>-</Text>
                      </td>
                      <td className={styles.td}>
                        <Text className={clsx(styles.firstLine, 'text-right mr-2 sm:mr-4')}>-</Text>
                        <Text
                          className={clsx(styles.secondLine, 'text-right mr-2 sm:mr-4 text-transparent')}
                        >
                          -
                        </Text>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td className={styles.td} colSpan='2'>
                      <Text className='text-lg text-center my-1.5'>
                        No hay documentos para mostrar
                      </Text>
                    </td>
                  </tr>
                  {[...Array(emptyRows).slice(1)].map((_, index) => (
                    <tr key={`empty-${index}`} className='gap-6 even:bg-secondary/20'>
                      <td className={styles.td}>
                        <Text className={clsx(styles.firstLine, 'pl-4 sm:pl-8')}>-</Text>
                        <Text className={clsx(styles.secondLine, 'pl-4 sm:pl-8 text-transparent')}>-</Text>
                      </td>
                      <td className={styles.td}>
                        <Text className={clsx(styles.firstLine, 'text-right mr-2 sm:mr-4')}>-</Text>
                        <Text
                          className={clsx(styles.secondLine, 'text-right mr-2 sm:mr-4 text-transparent')}
                        >
                          -
                        </Text>
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default TableTop5
